import styled from 'styled-components';

export const StyledTimerText = styled.div`
  font-feature-settings: 'tnum';
  font-family: 'TimerMonoSpaceFont';
`;

